import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { combineLatest, of } from 'rxjs';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';
import { StateFacade as OverviewFacade } from '../../facades/state.facade';
import { ErrorConstant, PLACE_HOLDER, SECTION_NAME } from '../../models';
import { DataLayerAnalyticsService } from '../../services/analytics/data-layer.service';
import { PersonalizationEngineService } from '../../services/api/personalization-engine.service';
import { getMultiplePERequest } from '../../utils/common-pe-request.utils';
import * as OverviewActions from '../actions/api.actions';

@Injectable()
export class PersonalizationEngineEffects {
  loadMultiplePEData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OverviewActions.loadMultiplePE),
      switchMap(() =>
        combineLatest([
          this.overview.trackerContent$.pipe(
            filter((trackerContent) => !!trackerContent),
            take(1)
          ),
          this.overview.peRequest$.pipe(
            filter((peRequest) => !!peRequest.currentDate),
            take(1)
          ),
          this.overview.aemErrorMessages$.pipe(
            filter((aemErrorMessages) => aemErrorMessages !== undefined),
            take(1)
          )
        ]).pipe(
          switchMap(([trackerContent, payload, aemErrorMessages]) => {
            const stateParam = trackerContent;
            const requestParams = getMultiplePERequest(payload, stateParam);
            return this.pe.getMultipleContent(requestParams).pipe(
              map((content) =>
                OverviewActions.loadMultiplePESuccess({
                  personalizationEngine: {
                    id: 'multiple-pe-content',
                    multiplePEContent: content
                  }
                })
              ),
              catchError((error: HttpErrorResponse) => {
                const message = aemErrorMessages.find((item) => {
                  return item.component === 'micromoment';
                });
                this.dataLayer.setErrorData(
                  error,
                  message.errorMessageDescription,
                  ErrorConstant.EVENT_NAME.replace(
                    PLACE_HOLDER,
                    SECTION_NAME.PERSONALIZATION
                  ),
                  ErrorConstant.TYPE.replace(
                    PLACE_HOLDER,
                    SECTION_NAME.PERSONALIZATION
                  )
                );
                return of(
                  OverviewActions.loadMultiplePEFailure({
                    error: {
                      id: 'multiple-pe-content-error',
                      multiplePEContentError: 'multiple-pe'
                    }
                  })
                );
              })
            );
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private readonly pe: PersonalizationEngineService,
    private readonly overview: OverviewFacade,
    protected dataLayer: DataLayerAnalyticsService
  ) {}
}
